module.exports = __webpack_public_path__ + "img/chevron-right-solid.8c9428f7.svg";